export function sleep(ms: number, signal?: AbortSignal) {
    if (ms <= 0) return Promise.resolve();

    return new Promise<void>((resolve, reject) => {
        const t = window.setTimeout(() => {
            cleanup();
            resolve();
        }, ms);

        const onAbort = () => {
            cleanup();
            reject(new DOMException("Aborted", "AbortError"));
        };

        const cleanup = () => {
            window.clearTimeout(t);
            if (signal) signal.removeEventListener("abort", onAbort);
        };

        if (signal) {
            if (signal.aborted) return onAbort();
            signal.addEventListener("abort", onAbort, { once: true });
        }
    });
}
